module.exports = __webpack_public_path__ + "img/w30b.1d4227ce.jpg";